<template>
  <div class="image-input image-input-empty" data-kt-image-input="true" :style="{backgroundImage: 'url(' + image +')'}">
    <div class="image-input-wrapper img-fluid" :class="[imageClass || 'w-125px h-125px']" :style="{backgroundImage: 'url(' + image +')'}"></div>

    <label class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
           data-kt-image-input-action="change"
           data-bs-toggle="tooltip"
           data-bs-dismiss="click"
           :title="$t('changeAvatar')">
      <i class="bi bi-pencil-fill fs-6"><span class="path1"></span><span class="path2"></span></i>

      <input v-on:change="onImageChange" type="file" name="avatar" accept=".png, .jpg, .jpeg" />
      <input type="hidden" name="avatar_remove" />
    </label>
    <span class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
          data-kt-image-input-action="cancel"
          data-bs-toggle="tooltip"
          data-bs-dismiss="click"
          :title="$t('cancelAvatar')">
        <i class="bi bi-x fs-3"></i>
    </span>
    <span v-on:click="removeImage" class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
          data-kt-image-input-action="remove"
          data-bs-toggle="tooltip"
          data-bs-dismiss="click"
          :title="$t('removeAvatar')">
        <i class="bi bi-x fs-3"></i>
    </span>
  </div>
  <div class="text-muted fs-7">{{ $t('promotion.type_file') }}</div>
</template>

<script>
export default {
  // defaultImage : image affichée tant qu'aucune n'est choisie (sinon l'avatar vide du thème)
  props: ['currentImage', 'imageClass', 'defaultImage'],
  data() {
      return {
          newImage: null
      }
  },
  watch: {
    newImage: function () {
      KTImageInput.createInstances();
    }
  },
  mounted() {
    this.newImage = this.currentImage
  },
  computed: {
    image(){
      return this.newImage || this.defaultImage || '/assets/media/avatars/blank.png'
    },
  },
  methods: {
    onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.$emit('update:image', files[0])
      this.newImage = files[0]
    },
    removeImage(e) {
      this.$emit('update:image', null)
      this.newImage = null
    }
  }
}
</script>

<style scoped>
/* Aperçu recadré au centre (le thème cadre en haut à gauche, ce qui coupe l'image) */
.image-input,
.image-input .image-input-wrapper {
  background-position: center;
  background-repeat: no-repeat;
}
</style>
